up.migrate.renamedProperty(up.RenderResult.prototype, 'options', 'renderOptions', 'up.RenderResult: Property { options } has been renamed to { renderOptions }');
